module.exports = __webpack_public_path__ + "static/img/33.cd23245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/33.png
// module id = FvUJ
// module chunks = 0